import { supabase } from './supabase';

export async function getOficinaId() {
  const { data: authData, error: authError } = await supabase.auth.getUser();
  if (authError) throw authError;

  const email = authData?.user?.email;
  if (!email) return null;

  const { data: userRow, error } = await supabase
    .from('usuarios')
    .select('oficina_id')
    .eq('email', email)
    .maybeSingle();

  if (error) throw error;
  return userRow?.oficina_id || null;
}

export async function getOfficeContext() {
  const { data: authData } = await supabase.auth.getUser();
  const email = authData?.user?.email;
  if (!email) return { officeId: null, userRow: null, authUser: null };

  const { data: userRow } = await supabase
    .from('usuarios')
    .select('*')
    .eq('email', email)
    .maybeSingle();

  return {
    officeId: userRow?.oficina_id || null,
    userRow: userRow || null,
    authUser: authData.user,
  };
}
